import { z } from 'zod'

import { productSchema } from './product.schemas'

export enum NCCResponseStatus {
  OneAddressFound = 'OneAddressFound',
  ManyAddressFound = 'ManyAddressFound',
  TooManyAddressesFound = 'TooManyAddressesFound',
  NoAddressFound = 'NoAddressFound',
}

export const premiseSchema = z.object({
  premiseId: z.string(),
  uprn: z.string(),
  hasActiveService: z.boolean(),
  propertyName: z.nullable(z.string()).optional(),
  streetNumber: z.string().optional(),
  streetName: z.string(),
  postcode: z.string(),
  locality: z.nullable(z.string()).optional(),
  city: z.string(),
  country: z.string(),
  longitude: z.nullable(z.string()).optional(),
  latitude: z.nullable(z.string()).optional(),
  addressDisplay: z.array(z.string()).nullable().optional(),
})

export const installationDetailsSchema = z
  .object({
    products: z.array(productSchema.strip()).optional(),
    productsByContract: z
      .array(
        z.object({
          title: z.string().optional(),
          products: z.array(productSchema.strip()).optional(),
        }),
      )
      .optional(),
    installFieldVisitRequired: z.boolean().optional(),
  })
  .optional()

export const nccProductsByUPRNResponseSchema = z
  .object({
    status: z.nativeEnum(NCCResponseStatus),
    premises: z.array(premiseSchema.strip()).optional(), // could be optional if UPRN from loqate not in Virgin Media NCC
    installationDetails: installationDetailsSchema.optional(), // could be absent if UPRN/premise exists, but there are no products
    transactionId: z.string(),
  })
  .strip()

export const amendmentProductsSchema = z.object({
  products: z.record(
    z.string(),
    z.object({
      valid: z.boolean(),
    }),
  ),
})
